import styled from 'styled-components';

const NameEmailWrapper = styled.div`
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const PostcodeLookupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export {
  NameEmailWrapper,
  AddressWrapper,
  PostcodeLookupWrapper
};
